if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super();
        
        if(window.innerWidth < 600){
          var swiper = new Swiper("product-media .swiper", {
            loop: true,
            autoHeight: true,
            autoplay: { delay: 5000 },
            slidesPerView: 1,
          });
        }else{
          $('product-media img').ezPlus({
              zoomType: 'inner',
              cursor: 'zoom-in'
          });
        }

        document.querySelectorAll(".product-media-videos").forEach(videoEl => {
            const myInterval = setInterval(autoplayVideo, 100);
        	function autoplayVideo() {
                if(videoEl.paused){
                    videoEl.play();
                    clearInterval(myInterval);
                }else clearInterval(myInterval);
            }
        })
      }
    }
  )
}




